import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from './UserContext';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import { Container } from 'reactstrap';
import { DashboardGrid, SearchGrid, TrafficGrid } from './DashboardGrid';
import { SearchFields, dashStatus } from '../services/interfaces';
import { PageContext } from './PageContext';
import { gSettings } from './Configuration';
import { GlobalSettings } from '../services/interfaces';
import { useSearchParams } from 'react-router-dom';
import { GridColumnReorderEvent } from '@progress/kendo-react-grid';
import { updateDashCols } from '../services/apiService';



interface dashCol{
    field:string,
    title:string,
    width:number,
    filter:boolean,
    format:string,
    minScreenWidth:number
}

interface dashboard{
    grid:string
    export:boolean
    columns:dashCol[]
}


export default function Home (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const page = pageContext?.page;
    const user = userContext?.user;    
    const [selected, setSelected] = useState<number>(0);
    const [dashStat, setDashStat] = useState<dashStatus>();
    const [dashCols, setDashCols] = useState<dashboard[]>([]);
    const [trafficCols, setTrafficCols] = useState<dashboard[]>([]);
    //const [searchFields,setSearchFields]=useState<SearchFields>();
    const handleSelect = (e: TabStripSelectEventArguments) => {
        pageContext?.setSelectedTab(e.selected);
    };

    const [SearchParams] = useSearchParams();
    const ad = SearchParams.get('ad')?.replace(".PDF","").replace(".pdf","");
    async function dashData(){
        const userDir = "users/" + user?.username;
        const dashStatPath = userDir + "/dashStatus.json";
        await fetch(dashStatPath)
            .then((response) => response.json())
            .then((data) => setDashStat(data));
    };

    async function getDashCols() {
        const userDir = "users/" + user?.username;
        const dashColsPath = userDir + "/dashCols.json";    
        await fetch(dashColsPath)
            .then((response) => response.json())
            .then((data) => setDashCols(data));
    }

    function getCols(grid:string){
        const cols=()=>dashCols.find(db=>db.grid===grid)?.columns || [];
        return (cols);
    }

    function getExport(grid:string){
        const exp=()=>dashCols.find(db=>db.grid===grid)?.export||false;
        return (exp);
    }

    const reorderColumn=(e:GridColumnReorderEvent)=>{
            console.log(e);
            const newOrder = e.columns.sort((a,b)=>(a.orderIndex ?? 0)-(b.orderIndex ?? 0));
            console.log(newOrder);
            var newCols:dashCol[]=[];
            var dash:dashboard | undefined;
            switch (e.target.props.id){
                case "DB1":
                    dash = dashCols.find((ds)=>ds.grid==="Dashboard1");
                    break;
                case "DB2":
                    dash = dashCols.find((ds)=>ds.grid==="Dashboard2");
                    break;
                case "DB3":
                    dash = dashCols.find((ds)=>ds.grid==="Dashboard3");
                    break;
                case "DB4":
                    dash = dashCols.find((ds)=>ds.grid==="Dashboard4");
                    break;
                case "DB5":
                    dash = dashCols.find((ds)=>ds.grid==="Watchlist");
                    break;
            }            
            newOrder.forEach((col)=>{
                 const foundCol = dash?.columns.find((dc) => dc.field === col.field);
                 if (foundCol) {
                     newCols.push(foundCol);
                 }
            })
            const newDashCols = dashCols.map(item=>{
                if (item.grid===dash?.grid){
                    return {...item,columns: newCols};
                }else{
                    return item;
                }
            });
            setDashCols(newDashCols);
            updateDashCols(JSON.stringify(newDashCols));
            console.log(newDashCols);            
        }

    function checkQuery(){
        if (ad){
            var sFields:SearchFields={
                archive:false,
                proofOnly:false,
                omitSpec:false,
                omitNewAd:false,
                adNum:ad||"",
                status: [],
                statusMatch:"1",
                customer:{customer:"",fileSize2:"",file1:""},
                account:"",
                salesRep:[],
                color:"Select color",
                adType:"Ad type",
                section:[],
                team:[],
                size:"",
                colType:[],
                site:[],
                publication:[],
                whiteGlove:{text:"White Glove", value:""},
                tagline:"",
                dateType:{ text: "Any run date", value: "0" },
                fixedDate:{text: "Select date", value: "" },
                fixedDay:"",
                startDay:{text: "Start day", value: "" },
                endDay:{text: "End day", value: "" },
                startDate:"",
                endDate:"",
                allGroup:false,
                groupName:"",
                queryName:"",
                queryIsGlobal:false,
                savedQueries:"",
                issue:""
            };
            pageContext?.setPage({...pageContext.page, fields: JSON.stringify(sFields)});
            pageContext?.setSelectedTab(5);
        }
    }

    function getGrids(){
        if (userContext?.user.trafficUser==false){
            return(
                <TabStrip selected={pageContext?.selectedTab} onSelect={handleSelect}>
                    <TabStripTab title={dashStat?.Dash1Title}>
                        {dashStat?.Dash1Status && dashCols && <DashboardGrid id="DB1" statuses={dashStat.Dash1Status} export={getExport("Dashboard1")()} cols={dashCols.find(db=>db.grid==="Dashboard1")?.columns || []} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title={dashStat?.Dash2Title}>
                    {dashStat?.Dash2Status && <DashboardGrid id="DB2" statuses={dashStat.Dash2Status} export={getExport("Dashboard2")()} cols={getCols("Dashboard2")()} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title={dashStat?.Dash3Title}>
                        {dashStat?.Dash3Status && <DashboardGrid id="DB3" statuses={dashStat.Dash3Status} export={getExport("Dashboard3")()} cols={getCols("Dashboard3")()} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title={dashStat?.Dash4Title}>
                        {dashStat?.Dash4Status && <DashboardGrid id="DB4" statuses={dashStat.Dash4Status} export={getExport("Dashboard4")()} cols={getCols("Dashboard4")()} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title="Watchlist">
                    {dashStat?.Dash4Status && <DashboardGrid id="DB5" statuses="watchlist" export={getExport("Watchlist")()} cols={getCols("Watchlist")()}reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title="Search Results">
                        <SearchGrid id="Search" statuses='search' export={getExport("Search")()} cols={getCols("Search")()} reorderCols={reorderColumn}/>
                    </TabStripTab>
                </TabStrip>
            )
        }else{
            return(
                <TabStrip selected={pageContext?.selectedTab} onSelect={handleSelect}>
                    <TabStripTab title={dashStat?.TrafficTitle}>

                        <TrafficGrid id="Traffic" statuses={""} export={getExport("Traffic")()} cols={getCols("Traffic")()} reorderCols={reorderColumn}/>
                    </TabStripTab>
                     <TabStripTab title={dashStat?.Dash4Title}>
                        {dashStat?.Dash4Status && <DashboardGrid id="DB4" statuses={dashStat.Dash4Status} export={getExport("Dashboard4")()} cols={getCols("Dashboard4")()} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title="Watchlist">
                        {dashStat?.Dash4Status && <DashboardGrid id="DB5" statuses="watchlist" export={getExport("Watchlist")()} cols={getCols("Watchlist")()} reorderCols={reorderColumn}/>}
                    </TabStripTab>
                    <TabStripTab title="Search Results">
                        <SearchGrid id="Search" statuses='search' export={getExport("Search")()} cols={getCols("Search")()} reorderCols={reorderColumn}/>
                    </TabStripTab>
                </TabStrip>
            )
        }
    }


    useEffect(() => {   
        if (user?.loggedIn){         
            getDashCols().then(data=>dashData().then(data=>pageContext?.setShowLoading(false)));
            checkQuery();
            //dashData();        
        }else{
            window.location.replace("/Login");
        }
    }, []);
    return (
        <>
        {user?.loggedIn ?
        <Container fluid>          
                    
            {getGrids()}
                
        </Container>
        : <></>}
        </>
    );
}

